

import {
    Button as BotonMaterial,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";

import { Button } from "react-admin";

import { useForm } from "react-final-form";

import { DeleteForever } from "@material-ui/icons";

import React, { useState } from "react";

let count = 0;


/*
Propiedades a enviar: - collectionName: nombre de la coleccion donde se van a guardar los registros en el formulario
                      - genericTableRow: componenete de React que describe la estructura de los campos a ingresar en los row (un ejemplo es AntibioticInterpretationField) 
                      - headers: headers de la tabla
                      - body: campos que tienen los registros de la tabla
*/

export const GenericTable = (props) => {
    count++;
    const form = useForm();
    const [reload, setReload] = useState(0);


    var formdata = form.getState().values;
    //console.log("Los datos son: ", formdata);

    const collection = formdata[props.collectionName] ?? [];
    const GenericTableRow = props.genericTableRow;

    const agregarFila = function () {
        collection.push(props.body);
        form.change(props.collectionName, collection);
        setReload(p => p + 1);
    };

    const DeleteButton = (props) => {
        const index = props.index;
        return (
            <TableCell align="left">
                <Button
                    variant="outlined"
                    onClick={() => eliminarFila(index)}
                >
                    <DeleteForever></DeleteForever>
                </Button>
            </TableCell>)
    }

    const eliminarFila = (index) => {
        if (collection[index].id) {
            collection[index].notes = "DELETED";
            collection[index].flag_deleted = true;
        }
        else {
            collection.splice(index, 1);
        }
        form.change(props.collectionName, collection);
        setReload(p => p + 1);
    };
    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="Generic table">
                <TableHead>
                    <TableRow key={count}>
                        {
                            props.headers.map(header => <TableCell align="left">{header}</TableCell>)
                        }
                        <TableCell align="left">
                            <BotonMaterial
                                variant="outlined"
                                onClick={agregarFila}
                            >
                                Agregar
                            </BotonMaterial>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        collection.map((row, index) => {
                            if (!row.flag_deleted) {
                                return <GenericTableRow index={index} source={props.collectionName} deleteButton={DeleteButton}></GenericTableRow>
                            }
                            return null;
                        })
                    }
                </TableBody>
            </Table>
        </TableContainer>
    );
}